import React from 'react';
import { useNavigate, useSubmit, useActionData, useLoaderData, redirect } from 'react-router-dom';
import { ContentFrame } from '../../components/content_frame/content_frame';
import {getModel} from '../../utils/functions';
import { DESKTOP_PATH, DOCUMENT_LIST_PATH, DOCUMENT_ADD_PATH, DOCUMENT_EDIT_PATH, LOGIN_PATH } from '../../constants/paths';
import { DOCUMENT_GET_API } from '../../constants/apis';
import { DocumentData } from './document_data';


const DEFAULT_DOCUMENT = {
  name: "",
  description: ""
};

export async function documentAddLoader() {
  return DEFAULT_DOCUMENT;
};

export async function documentEditLoader({ params }) {
  try {
    return await getModel(`${DOCUMENT_GET_API}${params.document_id}`);
  }
  catch(errors) {
    if(errors instanceof Array) {
      for(let error of errors) {
        if(error.code === 209) {
          // Expired user session
          return redirect(LOGIN_PATH);
        }
        else if(error.code === 203) {
          // Not authorized
          return redirect(DESKTOP_PATH);
        }
      }
    }

    throw errors;    
  }
};


class Document extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      document: {
        ...this.props.document
      }
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.document !== this.props.document) {
      this.setState({
        document: {
          ...this.props.document
        }
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    const newData = {...this.state.document, [name]: value};

    this.setState({
      document: newData
    });
  }

  inputsAreValid() {    
    return this.state.document.name.length > 0;
  }

  clearWarningMessage() {
    this.props.submit(
      {resetWarnings: true}, 
      {
        method: 'POST',
        encType: "application/json"
      });
  }

  async saveData() {
    let data = {...this.state.document};
    
    this.props.submit(
      {data}, 
      {
        method: this.props.isEdit ? 'PATCH' : 'POST',
        encType: "application/json"
      });
  }

  render() {
    return (
      <ContentFrame
        headerHistory={[
          {
            path: DESKTOP_PATH,
            text: "Área de trabalho"
          },
          {
            path: DOCUMENT_LIST_PATH,
            text: "Listar documentos"
          },
          {
            path: this.props.isEdit ? DOCUMENT_EDIT_PATH : DOCUMENT_ADD_PATH,
            text: this.props.isEdit ? 'Editar documento' : 'Adicionar documento'
          },
        ]}
        titleIcon={this.props.isEdit ? <i className="fas fa-edit"></i> : <i className="fas fa-plus"></i>}
        title={this.props.isEdit ? 'Editar documento' : 'Adicionar documento'}
      >

        <DocumentData
          warningMessage={this.props.warningMessage}
          showWarningMessage={this.props.warningMessage.length > 0}
          document={this.state.document}
          onSave={() => this.saveData()}
          onCloseWarning={() => this.clearWarningMessage()}
          enableSave={this.inputsAreValid()}
          handleInputChange={(event) => this.handleInputChange(event)}
          highlights={this.props.parametersToHighlight}
          onCancelPath={DOCUMENT_LIST_PATH}
        />

      </ContentFrame>
    );
  }
};

const WrappedDocument = props => {
  const document = useLoaderData();
  const navigate = useNavigate();
  const submit = useSubmit();
  const actionData = useActionData();

  let warningMessage = '';
  let parametersToHighlight = [];

  if (actionData) {
    warningMessage = actionData.message || '';
    parametersToHighlight = actionData.parameters || [];
  }  

  return (
    <Document
      navigate={navigate}
      submit={submit}
      warningMessage={warningMessage}
      parametersToHighlight={parametersToHighlight}
      document={document}
      {...props}
    />
  );
};

export { WrappedDocument as Document};
